export default __webpack_public_path__ + "static/card_3-f27daf5be302d748ae12109a3270e803.png";